import { ReactNode } from "react"
import { classes } from "../../../../../../../../shared/react/react"
import { isString } from "../../../../../../../../shared/utils/utils"


export function OptionIcon({ icon }: { icon: ReactNode }) {

    if (!icon) {
        return null
    }

    return <>
        {
            isString(icon)
                ? <i className={classes(icon)} />
                : icon

        }
    </>

}

export function getIconWithOption(icon: string, option: string) {

    return <div className="flex-row spc-3px" style={{ display: "inline-flex" }}>
        <i className={classes(icon)} />
        <i className="fas fa-plus fa-xs text-muted separator" />
        <i className={classes(option)} />
    </div>

}